import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { theme } from '../../themes/theme'

const excelColor = 'rgba(55, 209, 116, 1)'
const wordColor = 'rgba(46, 118, 208, 1)'
const pdfColor = 'rgba(226, 75, 61, 1)'
const emailColor = 'rgba(73, 104, 170, 1)'
const defaultColor = 'rgba(156, 163, 175, 1)'

const extensionColors = {
  '.XLS': excelColor,
  '.XLSX': excelColor,
  '.PDF': pdfColor,
  '.DOC': wordColor,
  '.DOCX': wordColor,
  '.EML': emailColor,
  '.MSG': emailColor,
  default: defaultColor
}

const Badge = styled.div`
  padding: 4px 4px;
  border-radius: ${theme.borderRadius.iconButton};
  background-color: ${props => props.bgColor};
  color: #ffffff;
  font-size: 12px;
  font-weight: 600;
  width: fit-content;
`

const FileExtension = ({ fileExtension }) => (
  <Badge bgColor={extensionColors[fileExtension.toUpperCase()] || extensionColors.default}>{fileExtension.toUpperCase()}</Badge>
)

FileExtension.propTypes = {
  fileExtension: PropTypes.string.isRequired
}

export default FileExtension
